import React, { useState, useEffect } from 'react';
import { CookiesConsentType } from 'types/CookiesConsentType';
import { CookieConsentContext } from './CookieConsentContext';
import Cookies from 'js-cookie';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const CookieConsentProvider: React.FC = ({ children }) => {
  const [cookieBannerChecked, toggleCookieBannerChecked] =
    useState<boolean>(false);
  const [cookiesConsent, setCookiesConsent] = useState<CookiesConsentType>({
    essential: true,
    functional: false,
    analytics: false,
    marketing: false,
    social: false,
  });

  useEffect(() => {
    const storedConsent = Cookies.get('cookieConsent');
    if (storedConsent) {
      try {
        const parsedConsent = JSON.parse(storedConsent);
        setCookiesConsent(parsedConsent);
        updateGTMConsent(parsedConsent);
      } catch (error) {
        console.error('Error parsing cookie consent:', error);
      }
    }
  }, []);

  useEffect(() => {
    if (cookieBannerChecked) {
      Cookies.set('cookieConsent', JSON.stringify(cookiesConsent), {
        expires: 365,
      });
      updateGTMConsent(cookiesConsent);
      cookieEventTrigger();
    }
  }, [cookiesConsent, cookieBannerChecked]);

  const updateGTMConsent = (consent: CookiesConsentType) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'default_consent',
      consent: {
        analytics_storage: consent.analytics ? 'granted' : 'denied',
        ad_storage: consent.marketing ? 'granted' : 'denied',
        ad_user_data:
          consent.marketing && consent.analytics ? 'granted' : 'denied',
        ad_personalization: consent.marketing ? 'granted' : 'denied',
      },
    });
  };

  const cookieEventTrigger = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'brij-cookies-initiation',
    });
  };

  return (
    <CookieConsentContext.Provider
      value={{
        cookiesConsent,
        setCookiesConsent,
        cookieBannerChecked,
        toggleCookieBannerChecked,
      }}
    >
      {children}
    </CookieConsentContext.Provider>
  );
};
